// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__U7tIj"};